module.exports = __webpack_public_path__ + "bb.svg?0dca8c8f07eeeedf76c5bcce4d949082";